import { useEffect, useState } from 'react';

import { useBrand } from '@cof/plastic-components';
import config from '@cof/ukweb-config/lib/clientConfig';
import { useAdobeExperiments } from '../../experiments/AdobeExperiment/AdobeExperimentProvider';
import { getFullExperimentString } from '../../experiments/getExperimentString';
import { setNewRelicAttribute } from '../newRelic';

window.initializeZuko = (slug: any, isEnabled: any) => {
    if (isEnabled && window.Zuko && window.zukoAttributes && !window.zukoInstance) {
        const zukoAttr = window.zukoAttributes;
        const zukoVisitorId = window?.Zuko?.getVisitorId?.();

        if (zukoVisitorId) setNewRelicAttribute('zukoVisitorId', zukoVisitorId);

        window.zukoInstance = window.Zuko.trackForm({ slug, target: zukoAttr.formEl })
            .setAttribute('formDefinitionId', zukoAttr.formDefinitionId)
            .setAttribute('onlineEntryMethodCode', zukoAttr.onlineEntryMethodCode)
            .setAttribute('journeyType', zukoAttr.journeyType)
            .setAttribute('consumerName', zukoAttr.consumerName)
            .setAttribute('doubleClickId', zukoAttr.doubleClickId)
            .setAttribute('experimentChar', zukoAttr.experimentChar)
            .setAttribute('webpage', zukoAttr.webpage)
            .setAttribute('AdobeExperiment', zukoAttr.AdobeExperiment)
            .trackEvent(window.Zuko.FORM_VIEW_EVENT);
    }
};

// eslint-disable-next-line import/prefer-default-export
export const useZuko = ({
    formDefinitionId,
    onlineEntryMethodCode,
    consumerName,
    journeyType,
    doubleClickId,
    experimentChar,
    webpageChar
}: any) => {
    const [formEl, setFormEl] = useState(null);
    const brand = useBrand();
    const zukoConfig = config.get('zuko');
    // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type '"capitalOneSlug" | "lumaSlug" | "ve
    const slug = zukoConfig[`${brand}Slug`] || zukoConfig.slug;
    const adobeState = useAdobeExperiments();

    useEffect(() => {
        const AdobeExperiment = getFullExperimentString(adobeState);

        // Validate the required attributes exist. doubleClickId & formDefinitionId is optional
        if (formEl && onlineEntryMethodCode && journeyType && consumerName) {
            window.zukoAttributes = {
                formEl,
                formDefinitionId,
                onlineEntryMethodCode,
                journeyType,
                consumerName,
                doubleClickId,
                experimentChar,
                webpage: webpageChar,
                AdobeExperiment
            };
        }
        // Also called in GTM Zuko tag
        // @ts-expect-error TS2722: Cannot invoke an object which is possibly 'undefined'.
        window.initializeZuko(slug, zukoConfig.isEnabled);
    }, [
        formEl,
        formDefinitionId,
        onlineEntryMethodCode,
        consumerName,
        journeyType,
        doubleClickId,
        experimentChar,
        webpageChar,
        adobeState,
        slug,
        zukoConfig.isEnabled
    ]);

    const trackCompletionEvent = () => {
        if (typeof window?.zukoInstance?.trackEvent === 'function') {
            try {
                // @ts-expect-error TS18048: 'window.Zuko' is possibly 'undefined'.
                window.zukoInstance.trackEvent(window.Zuko.COMPLETION_EVENT);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e);
            }
        }
    };

    const trackValidationError = (field: any) => {
        if (typeof window?.zukoInstance?.trackEvent === 'function') {
            try {
                window.zukoInstance.trackEvent({ type: `submit-validation-error:${field}` });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e);
            }
        }
    };

    return { setFormEl, trackCompletionEvent, trackValidationError };
};
